import { createSelector } from 'reselect';
import { 
// Features
featuresShowUpsellHintSelector, featuresShowJobSeekerBoneyardUpsellHintSelector, 
// Navigation
premiumUpsellHeaderSelector, proJobsUpsellHeaderSelector, } from '@xingternal/platform-layout-selectors';
const upsellButtonSelector = createSelector(featuresShowUpsellHintSelector, featuresShowJobSeekerBoneyardUpsellHintSelector, premiumUpsellHeaderSelector, proJobsUpsellHeaderSelector, (showUpsellHint, showJobSeekerBoneyardUpsellHint, premiumUpsellHeader, proJobsUpsellHeader) => {
    return {
        showUpsellHint,
        showJobSeekerBoneyardUpsellHint,
        link: showJobSeekerBoneyardUpsellHint
            ? proJobsUpsellHeader
            : premiumUpsellHeader,
    };
});
export { upsellButtonSelector };
//# sourceMappingURL=UpsellButton.selectors.js.map